import { Link, usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { Bookmark, ExternalLink } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../../Shared/UI/Icon';
import { useRouter } from '../../router';
import { DonationForm, PageProps } from '../../types';
import Container from '../../UI/Container';
import Header from '../../UI/Header';
import HeaderTitle from '../../UI/HeaderTitle';
import { tabClasses } from '../../UI/helpers';
import { SettingsLayout } from '../SettingsLayout';
import DonationFormToggle from './DonationFormToggle';

export function DonationFormLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { props: { donationForm }, component } = usePage<PageProps<{ donationForm: DonationForm; }>>();

  return (
    <SettingsLayout>
      <DonationFormHeader donationForm={donationForm} component={component} />
      {children}
    </SettingsLayout>
  );
}

export function DonationFormHeader({
  donationForm,
  component,
}: {
  donationForm: DonationForm;
  component: string;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  return (
    <Header>
      <Container className="!pb-0">
        <div className="flex items-center justify-between w-full">
          <div>
            <HeaderTitle className={classNames(!donationForm.enabled && 'opacity-50')}>
              {donationForm.internal_title}
            </HeaderTitle>
            {donationForm.default && (
              <div className="text-sm font-medium text-blue-500">
                <Icon className="mr-1">
                  <Bookmark />
                </Icon>
                {t('backend:default_donation_form')}
              </div>
            )}
          </div>

          <div className="flex items-center space-x-6">
            <a
              href={donationForm.url}
              target="_blank"
              rel="noopener noreferrer"
              data-supporta-embed="false"
              className="font-medium"
            >
              {t('backend:visit')}
              <Icon className="ml-1">
                <ExternalLink />
              </Icon>
            </a>
            <DonationFormToggle donationForm={donationForm} />
          </div>
        </div>

        <div className="mt-2 space-x-4">
          <Link
            href={routes.donation_form_page(donationForm.id)}
            className={tabClasses({ active: component === 'Backend/Settings/DonationForms/DonationFormPage' })}
          >
            {t('backend:overview')}
          </Link>
          <Link
            href={routes.donation_form_settings_page(donationForm.id)}
            className={tabClasses({ active: component === 'Backend/Settings/DonationForms/DonationFormSettingsPage' })}
          >
            {t('backend:settings')}
          </Link>
          <Link
            href={routes.donation_form_mails_page(donationForm.id)}
            className={tabClasses({ active: component === 'Backend/Settings/DonationForms/DonationFormMailsPage' })}

          >
            {t('backend:mails')}
          </Link>
        </div>
      </Container>
    </Header>
  );
}
